module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAABWklEQVRIx2NgmOpMKmrYpPj/HAObBKeGtcH///8bTi0kwxCGUYtHLcaCZnSrfXRRO8RlcITX5GNw2Yy5nfSwOC/QdoKM7kUO4y4ZnVZZ7b18hjNlDYCCJFsMDDfiEdCvL1nNO+R0TnMa94lazudxP8ZjPFVSFygIlCLJKAZgbBGP7jupVChrP2Mxe8Vibq6saCdkcYrF+AmLaZa61hMnVZKMYtAw4SAeXeY07JbSBtoKRH1SVSz6Ylc4TYDsOaK6VziNSDKKgU2Sn3h0kd1oroguxOKJEmm81vLe2qpAdpeU1kV2Y5KMYvhPCnjgn5+upfWUxewum3GejC6/kbSZriKQW66ifd8/jySjGIC5kHgEzDkv2SymSetuEFGfKCvhpcFdLiHbLaMLFARKkWQUOdlpkpz+ES6jdlmdTlmd0+xGU+TJyk5kFyD7OPWP8BrTrwAZrSRGLSYWAQDJLEHLBhsdGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/dm.png
// module id = 812
// module chunks = 0